import { motion } from "framer-motion";
import { LogoMark } from "./Logo";

export const Intro = () => (
  <motion.div
    data-testid="intro-curtain"
    initial={{ y: "0%" }}
    animate={{ y: "-100%" }}
    transition={{ duration: 1, ease: [0.76, 0, 0.24, 1], delay: 1.5 }}
    className="fixed inset-0 z-[100] bg-obsidian flex flex-col items-center justify-center pointer-events-none"
  >
    <LogoMark className="h-24 sm:h-32" draw />
    <motion.p
      initial={{ opacity: 0, letterSpacing: "0.1em" }}
      animate={{ opacity: 1, letterSpacing: "0.45em" }}
      transition={{ duration: 1.2, delay: 0.3 }}
      className="mt-6 font-mono text-[11px] uppercase text-ivory/80"
    >
      Hair Boutique
    </motion.p>
  </motion.div>
);
